import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import {
  BusinessOwnerForm,
  CompanyInformationForm,
  OnboardingAccordion,
  StoreDetailsForm,
} from "client/domain";
import { useRunOnce, useTranslation } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { logAmplitudeEvent } from "client/lib/amplitude";

const useStyles = makeStyles((theme: Theme) => {
  const { accordionDetailsSubtitleFg } = useNormalizedBrandPaletteValues(theme);

  return {
    accordionDetailsSubtitle: {
      fontSize: "0.9rem",
      lineHeight: "1.4rem",
      color: accordionDetailsSubtitleFg,
      marginBottom: theme.spacing(2),
    },
  };
});

export const BusinessDetailsForm: React.FC<{
  formSubtitleKey: string;
}> = ({ formSubtitleKey, children }) => {
  const classes = useStyles();
  const t = useTranslation();

  return (
    <Box width="100%">
      <Typography className={classes.accordionDetailsSubtitle} variant="body2">
        {t(formSubtitleKey)}
      </Typography>
      {children}
    </Box>
  );
};

export const BusinessDetailsForms: React.FC = () => {
  /* Once the three business details forms are broken out, we can implement
    events for each individual page load,
    right now since all 3 components are on the same "page",
    all three events fire off once this component loads if emitting an event
    from each form component
  */
  useRunOnce(() =>
    logAmplitudeEvent(
      "REDESIGN_ADD_YOUR_STORE",
      "loaded_business_details_forms"
    )
  );

  return (
    <OnboardingAccordion
      businessOwnerForm={
        <BusinessDetailsForm formSubtitleKey="uiBusinessFormOwnerSubtitle">
          <BusinessOwnerForm />
        </BusinessDetailsForm>
      }
      companyInformationForm={
        <BusinessDetailsForm formSubtitleKey="uiCustomerInfoSubtitle">
          <CompanyInformationForm />
        </BusinessDetailsForm>
      }
      storeDetailsForm={
        <BusinessDetailsForm formSubtitleKey="uiStoreDetailsSubtitle">
          <StoreDetailsForm />
        </BusinessDetailsForm>
      }
    />
  );
};
